var exports = {
  "qr": "EditingMessageInput.module__footer___cUJQWF",
  "s6": "EditingMessageInput.module__footerLink___cUJQWF",
  "me": "EditingMessageInput.module__separator___cUJQWF",
  "EN": "EditingMessageInput.module__editor___cUJQWF",
};

module.exports = exports;
